import React, { useState } from 'react';
import Input from '../../input/input';
import { Button } from '@material-ui/core';
import { navigate } from '@reach/router';
import { BACKEND_URL } from '../../../back-end-url';

const VerificationCode = ({ email }: any) => {
  const [emailVerificationCode, setCode] = useState('');
  return (
    <div>
      <h5>Введіть код безпеки</h5>
      Перевірте електронну пошту на наявність повідомлення з кодом. Ваш код має
      складатися із 6 цифр.
      <Input
        value={emailVerificationCode}
        changed={e => setCode(e.target.value)}
      />
      <p>Ми надіслали вам код на: {email}</p>
      <Button
        variant="contained"
        color="primary"
        data-e2e-id={'check-button'}
        onClick={() => {
          fetch(`${BACKEND_URL}/confirm-email`, {
            method: 'post',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              email,
              emailVerificationCode
            })
          })
            .then(res => res.json())
            .then(({ error, message, token }) => {
              if (error) {
                alert(message);
              } else {
                localStorage.setItem('token', token);
                navigate('/');
              }
            });
        }}
      >
        Перевірити
      </Button>
    </div>
  );
};

export default VerificationCode;
